import "@/legacy/warenkorb";

import "@/ui/warenkorb/lagerbestand";
import "@/ui/warenkorb/shareCart";
import "@/ui/warenkorb/warenkorbModal";

// OCI: Autosubmit der hidden Form zum SAP "Webservice"
$("form.oci-bestellung").trigger("submit");
